import { useState } from 'react';
import { Label } from '../components/ui/label';
import { cn } from '../lib/utils';

const PLANS = [
  { id: 'full', label: 'Pay in Full', months: 1, description: 'One-time payment' },
  { id: '3_months', label: '3 Months', months: 3, description: '3 payments' },
  { id: '6_months', label: '6 Months', months: 6, description: '6 payments' },
  { id: '12_months', label: '12 Months', months: 12, description: '12 payments' },
];

export const PaymentPlanSelector = ({ totalPrice, selectedPlan, onPlanChange }) => {
  const calculateMonthly = (months) => {
    return Math.round(totalPrice / months);
  };

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium">Choose Your Payment Plan</Label>
      <div className="grid grid-cols-4 gap-2">
        {PLANS.map((plan) => {
          const monthly = calculateMonthly(plan.months);
          const isSelected = selectedPlan === plan.id;
          
          return (
            <button
              key={plan.id}
              type="button"
              onClick={() => onPlanChange(plan.id)}
              className={cn(
                "relative p-2 rounded-lg border-2 text-center transition-all duration-200",
                isSelected 
                  ? "border-secondary bg-secondary/5" 
                  : "border-border hover:border-secondary/50"
              )}
              data-testid={`payment-plan-${plan.id}`}
            >
              {isSelected && (
                <div className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-secondary rounded-full flex items-center justify-center">
                  <svg className="w-2.5 h-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
              <p className="text-[10px] text-muted-foreground mb-0.5">{plan.label}</p>
              <p className="font-bold text-base text-primary leading-tight">
                ${monthly.toLocaleString()}
                {plan.months > 1 && <span className="text-[10px] font-normal text-muted-foreground">/mo</span>}
              </p>
              <p className="text-[9px] text-muted-foreground">{plan.description}</p>
            </button>
          );
        })}
      </div>
      
      {selectedPlan !== 'full' && (
        <p className="text-xs text-secondary">
          Total: ${totalPrice.toLocaleString()} in {PLANS.find(p => p.id === selectedPlan)?.months} payments
        </p>
      )}
    </div>
  );
};
